// extracted by mini-css-extract-plugin
export var backdropBlur = "_ks-0";
export var contentCard = "_ks-5";
export var frame = "_ks-2";
export var image = "_ks-4";
export var imagePane = "_ks-3";
export var modal = "_ks-1";